/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Typography } from '@atoms';
import { SortableArrayField, ColorField, ContentModuleModal, TextField } from '@molecules';
import { NO_MARGIN_BOTTOM, ULTIMATE_DESIGN_BACKGROUND_COLORS } from '@constants';
import useEventColors from '@hooks/useEventColors';

import Form from '../Form';

import Item from './Item';
import AddLink from './AddLink';
import LinkItem from './LinkItem';
import { CLASSIC_MAX_SOCIAL_LINKS, FORM_FIELD, INITIAL_VALUES, ULTIMATE_MAX_SOCIAL_LINKS } from './constant';

const initDesignChoices = (isUltimateDesign) => {
  if (isUltimateDesign)
    return {
      maxLinks: ULTIMATE_MAX_SOCIAL_LINKS,
      backgroundColorsField: { ...FORM_FIELD.BACKGROUND_COLOR, colors: ULTIMATE_DESIGN_BACKGROUND_COLORS },
      linksField: { ...FORM_FIELD.LINKS, rules: [{ min: 1, max: ULTIMATE_MAX_SOCIAL_LINKS }] },
    };
  return {
    maxLinks: CLASSIC_MAX_SOCIAL_LINKS,
    backgroundColorsField: FORM_FIELD.BACKGROUND_COLOR,
    linksField: FORM_FIELD.LINKS,
  };
};
const SocialMediaLinks = ({
  visible = true,
  onSubmit,
  hide,
  previewImg,
  onDelete,
  initialValues = INITIAL_VALUES,
  isUltimateDesign,
  errors,
}) => {
  const [form] = Form.useForm();
  const eventColors = useEventColors();
  const { maxLinks, backgroundColorsField, linksField } = initDesignChoices(isUltimateDesign);
  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleAddLink = (link) => {
    const previousLinks = form.getFieldValue(linksField.name);
    form.setFieldsValue({ [linksField.name]: [...previousLinks, link] });
  };
  return (
    <ContentModuleModal
      visible={visible}
      title="Social media links"
      subtitle={`Add your social media accounts, to show on the site footer. You can choose up to ${maxLinks} accounts.`}
      okText={onDelete ? 'SAVE CHANGES' : 'ADD SOCIAL MEDIA LINKS'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <AddLink onAdd={handleAddLink} />
      <Form form={form} onFinish={handleSubmit} initialValues={initialValues} layout="vertical">
        <SortableArrayField {...linksField} form={form} withCount withPlaceholder>
          {(url) => <LinkItem url={url} />}
        </SortableArrayField>
        <Typography.Title level={3} style={{ marginTop: 50 }}>
          Settings
        </Typography.Title>
        <TextField {...FORM_FIELD.TITLE} />
        <ColorField {...FORM_FIELD.COLOR} style={NO_MARGIN_BOTTOM} mergeColors={eventColors} />
        <ColorField {...backgroundColorsField} style={NO_MARGIN_BOTTOM} mergeColors={eventColors} />
      </Form>
    </ContentModuleModal>
  );
};

SocialMediaLinks.Item = Item;

export default SocialMediaLinks;
